import type { ConsumerCharacterAccessRecord } from 'dynamo-daos';

import { EnhancedGLTF } from '../types';
import apiRequest from './apiRequest';
import { withoutHiddenRobots } from '../characters/robotCharacters';

export type Character = InstanceType<typeof ConsumerCharacterAccessRecord> & {
  heroThumbnailPath: string;
  markerAdjustmentEligible: boolean;
  meshPath: string;
  referenceImagePath?: string;
  thumbnailPath: string;
  vertexCount: number;
  readyOn: Date | null;
  meshData: { current: EnhancedGLTF | null }; // valtio ref<>
  /** Bone object name from mapping JSON `role_to_bone.Head`, when resolved for external rigs. */
  headBoneName?: string;
  /** Presigned mapping JSON URL from external character list; used to lazy-resolve `headBoneName`. */
  characterConfigURL?: string;
  /** True after a lazy head-bone fetch was attempted (success or failure). */
  headBoneConfigFetched?: boolean;
};

type ApiResponse = {
  characters: Array<Character>;
};

export default async function getCharacters(
  limit?: number,
  nextToken?: string,
  sortAscending?: boolean,
) {
  const urlParams = new URLSearchParams();
  if (limit) {
    urlParams.set('limit', limit.toString());
  }
  if (nextToken) {
    urlParams.set('nextToken', nextToken);
  }
  if (sortAscending) {
    urlParams.set('sortAscending', sortAscending.toString());
  }

  const response = await apiRequest<ApiResponse>(
    'mogen-orchestration',
    `/characters${urlParams.toString() ? '?' : ''}${urlParams.toString()}`,
  );

  // Robots are hidden from every picker from here, so no surface has to remember to filter.
  // Fetching one by id is unaffected, which is what export and retarget rely on.
  if (response.data?.characters) {
    response.data.characters = withoutHiddenRobots(response.data.characters);
  }
  return response;
}
